import { Routes, Route } from 'react-router-dom';
import Dashboard from '../../pages/Dashboard';
import Notes from '../../pages/Notes';

const DashboardRoutes = () => {
    return <Routes>
          <Route
            path='/dashboard/:flow_meter_id/:from_datetime/:to_datetime'
            element={<Dashboard />}
          />
          <Route
            path='/notes/:flow_meter_id/:from_datetime/:to_datetime'
            element={<Notes />}
          />
    </Routes>
};

export default DashboardRoutes;